import { inlineElements, size } from '../constants';
export const isBlockElement = element => element && inlineElements.indexOf(element.type) === -1 && typeof element !== 'string';
export const spaceSetting = _ref => {
  let {
    verticalSpacing = 'sm',
    horizontalSpacing = 'sm',
    children = [],
    flex = false
  } = _ref;
  const verticalMargin = (size[verticalSpacing] || 0) / (flex ? 2 : 1);
  return "\n    margin: 0px -".concat((size[horizontalSpacing] || 0) / 2, "px;\n\n    ").concat(isBlockElement(children[0]) || flex ? "margin-top: -".concat(verticalMargin, "px;") : '', "\n    ").concat(isBlockElement(children[children.length - 1]) || flex ? "margin-bottom: -".concat(verticalMargin, "px;") : '', "\n\n    > * {\n      margin: ").concat(verticalMargin, "px ").concat((size[horizontalSpacing] || 0) / 2, "px;\n    }\n  ");
};
export const isEmptyObject = obj => Object.keys(obj).length === 0 && obj.constructor === Object;
//# sourceMappingURL=index.js.map